<template>
  <ModalWrapper v-show="isShowPopup" :model-name="modelName">
    <div class="settings_filters_popup">
      <div class="settings_filters_popup-holder">
        <img @click="closeFilter" class="settings_filters_popup-holder_head_icon" src="../../assets/icons/close.svg" alt="close close-filters" />
        <StepComponent
            v-if="currentStep"
            :step="currentStep.step"
            :title="currentStep.title"
            :subtitle="currentStep.subtitle"
            :options="currentStep.options"
            :current-step="currentStep"
            @select-item="handleSelect"
            @prev-step="prevStep"
            @next-step="nextStep"
            @generate="handleGenerate"
        />
      </div>
    </div>
  </ModalWrapper>
</template>
<script>
import { computed, ref, watch, onMounted } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import StepComponent from "./StepComponent.vue";
import ActionButtons from "./ActionButtons.vue";
import ModalWrapper from "@/components/modals/ModalWrapper.vue";
import PopupCard from "@/components/filter/PopupCard.vue";
import PopupCardPoses from "@/components/filter/PopupCardPoses.vue";
import { EffectFade, Pagination, Navigation } from "swiper";

// Cumshot
import cumshotNone from "@/assets/cumshot/woman.webp";
import cumshotNun from "@/assets/cumshot/nun.webp";
import cumshotTeacher from "@/assets/cumshot/teacher.webp";
import cumshotStudent from "@/assets/cumshot/student.webp";
import cumshotNurse from "@/assets/cumshot/nurse.webp";
// BBC
import noneBBCImg from "@/assets/bbc/woman.webp";
import nunBBCImg from "@/assets/bbc/nun.webp";
import schoolBBCImg from "@/assets/bbc/student.webp";
import teacherBBCImg from "@/assets/bbc/teacher.webp";
import nurseBBCImg from "@/assets/bbc/nurse.webp";
// Cum in mouth
import noneMouth from "@/assets/cumMouth/woman.webp";
import nunMouth from "@/assets/cumMouth/nun.webp";
import nurseMouth from "@/assets/cumMouth/nurse.webp";
import studentMouth from "@/assets/cumMouth/student.webp";
import teacherMouth from "@/assets/cumMouth/teacher.webp";
// Face Cum
import faceCumWoman from "@/assets/faceCum/woman.webp";
import faceCumNun from "@/assets/faceCum/nun.webp";
import faceCumNurse from "@/assets/faceCum/nurse.webp";
import faceCumSchool from "@/assets/faceCum/student.webp";
import faceCumTeacher from "@/assets/faceCum/teacher.webp";
// Dick Cum
import dickCumNone from "@/assets/dickCum/woman.webp";
import dickCumNun from "@/assets/dickCum/nun.webp";
import dickCumNurse from "@/assets/dickCum/nurse.webp";
import dickCumStudent from "@/assets/dickCum/student.webp";
import dickCumTeacher from "@/assets/dickCum/teacher.webp";
// Ahegao Japan
import ahegaoNone from "@/assets/ahegao/woman.webp";
import ahegaoNun from "@/assets/ahegao/nun.webp";
import ahegaoNurse from "@/assets/ahegao/nurse.webp";
import ahegaoStudent from "@/assets/ahegao/student.webp";
import ahegaoTeacher from "@/assets/ahegao/teacher.webp";
// Breast Clamp
import breastNone from "@/assets/breast/woman.webp";
import breastNun from "@/assets/breast/nun.webp";
import breastNurse from "@/assets/breast/nurse.webp";
import breastStudent from "@/assets/breast/student.webp";
import breastTeacher from "@/assets/breast/teacher.webp";
// Anal
import analNone from "@/assets/anal/woman.webp";
import analNun from "@/assets/anal/nun.webp";
import analTeacher from "@/assets/anal/teacher.webp";
import analStudent from "@/assets/anal/student.webp";
import analNurse from "@/assets/anal/nurse.webp";
// Mission
import missionNone from "@/assets/mission/woman.webp";
import missionNun from "@/assets/mission/nun.webp";
import missionTeacher from "@/assets/mission/teacher.webp";
import missionStudent from "@/assets/mission/student.webp";
import missionNurse from "@/assets/mission/nurse.webp";
// Gagged
import gaggedNone from "@/assets/gagged/woman.webp";
import gaggedNun from "@/assets/gagged/nun.webp";
import gaggedNurse from "@/assets/gagged/nurse.webp";
import gaggedTeacher from "@/assets/gagged/teacher.webp";
import gaggedStudent from "@/assets/gagged/student.webp";
// Titsjob
import titsjobNone from "@/assets/titsBlowjob/woman.webp";
import titsjobNun from "@/assets/titsBlowjob/nun.webp";
import titsjobNurse from "@/assets/titsBlowjob/nurse.webp";
import titsjobTeacher from "@/assets/titsBlowjob/teacher.webp";
import titsjobStudent from "@/assets/titsBlowjob/student.webp";
// Male Blowjob
import maleBlowJob from "@/assets/maleBlowjob/manBlowjob.webp";
import undressTypeImg from "@/assets/filter-type-image/undress.png";
import underwearImg from "@/assets/filter-underwear/black.webp";
import gartersImg from "@/assets/latex/black.webp";
import bikiniImg from "@/assets/filters-bikini/black.webp";

export default {
  name: "GenerationSelectStepPopup",
  components: { StepComponent, ActionButtons, ModalWrapper, PopupCard, PopupCardPoses },
  props: {
    isOpenFilters: Boolean,
    breastArr: {},
    backTypes: {},
    bodyTypes: {},
    ages: {},
    modelName: { type: String, default: "GenerationSelectStepPopup" },
    selectedType: { type: Number, default: 1 },
    hasOneTrial: { type: Boolean, default: false }
  },
  setup(_, { emit }) {
    const store = useStore();
    const { t } = useI18n();
    const activeStep = ref(1);
    const activeGenerationType = ref(1);
    const activeUndressListType = ref(1);
    const activeTits = ref(1);
    const activeBack = ref(1);
    const activeBody = ref(1);
    const activeAge = ref(1);
    const selectedPoses = ref(1);
    const selectedOutfits = ref(1);
    const undressLists = [
      { id: 1, title: t('filters.undressBlock.underwear'), img: underwearImg, premium: false },
      { id: 2, title: t('filters.undressBlock.garters'), img: gartersImg, premium: false },
      { id: 3, title: t('filters.undressBlock.bikini'), img: bikiniImg, premium: false },
    ];
    const cumshotTypes = [
      { id: 1, title: t('filters.ahegao.none'), img: cumshotNone, value: 'none' },
      { id: 2, title: t('filters.ahegao.nun'), img: cumshotNun, value: 'nun' },
      { id: 4, title: t('filters.ahegao.school'), img: cumshotStudent, value: 'student' },
      { id: 3, title: t('filters.ahegao.teacher'), img: cumshotTeacher, value: 'teacher' },
      { id: 5, title: t('filters.ahegao.nurse'), img: cumshotNurse, value: 'nurse' },
    ]
    // BBC
    const bbcTypes = [
      { id: 1, title: t('filters.ahegao.none'), img: noneBBCImg, value: 'none' },
      { id: 2, title: t('filters.ahegao.nun'), img: nunBBCImg, value: 'nun' },
      { id: 3, title: t('filters.ahegao.student'), img: schoolBBCImg, value: 'student' },
      { id: 4, title: t('filters.ahegao.teacher'), img: teacherBBCImg, value: 'teacher' },
      { id: 5, title: t('filters.ahegao.nurse'), img: nurseBBCImg, value: 'nurse' },
    ]
    // Cum in mouth
    const cumMouthTypes = [
      { id: 1, title: t('filters.ahegao.none'), img: noneMouth, value: 'none' },
      { id: 2, title: t('filters.ahegao.nun'), img: nunMouth, value: 'nun' },
      { id: 3, title: t('filters.ahegao.student'), img: studentMouth, value: 'student' },
      { id: 4, title: t('filters.ahegao.teacher'), img: teacherMouth, value: 'teacher' },
      { id: 5, title: t('filters.ahegao.nurse'), img: nurseMouth, value: 'nurse' },
    ]
    // Cum Face
    const faceCumTypes = [
      { id: 1, title: t('filters.ahegao.none'), img: faceCumWoman, value: 'none' },
      { id: 2, title: t('filters.ahegao.nun'), img: faceCumNun, value: 'nun' },
      { id: 3, title: t('filters.ahegao.school'), img: faceCumSchool, value: 'student' },
      { id: 4, title: t('filters.ahegao.teacher'), img: faceCumTeacher, value: 'teacher' },
      { id: 5, title: t('filters.ahegao.nurse'), img: faceCumNurse, value: 'nurse' },
    ]
    // Dick Cum
    const dickCumTypes = [
      { id: 1, title: t('filters.ahegao.none'), img: dickCumNone, value: 'none' },
      { id: 2, title: t('filters.ahegao.nun'), img: dickCumNun, value: 'nun' },
      { id: 3, title: t('filters.ahegao.student'), img: dickCumStudent, value: 'student' },
      { id: 4, title: t('filters.ahegao.teacher'), img: dickCumTeacher, value: 'teacher' },
      { id: 5, title: t('filters.ahegao.nurse'), img: dickCumNurse, value: 'nurse' },
    ]
    // Ahegao
    const ahegaoTypes = [
      { id: 1, title: t('filters.ahegao.none'), img: ahegaoNone, value: 'none' },
      { id: 2, title: t('filters.ahegao.nun'), img: ahegaoNun, value: 'nun' },
      { id: 3, title: t('filters.ahegao.school'), img: ahegaoStudent, value: 'student' },
      { id: 4, title: t('filters.ahegao.teacher'), img: ahegaoTeacher, value: 'teacher' },
      { id: 5, title: t('filters.ahegao.nurse'), img: ahegaoNurse, value: 'nurse' },
    ]
    // Breast Clamp
    const breastTypes = [
      { id: 1, title: t('filters.ahegao.none'), img: breastNone, value: 'none' },
      { id: 2, title: t('filters.ahegao.nun'), img: breastNun, value: 'nun' },
      { id: 3, title: t('filters.ahegao.student'), img: breastStudent, value: 'student' },
      { id: 4, title: t('filters.ahegao.teacher'), img: breastTeacher, value: 'teacher' },
      { id: 5, title: t('filters.ahegao.nurse'), img: breastNurse, value: 'nurse' },
    ]
    // Gagged
    const gaggedTypes = [
      { id: 1, title: t('filters.ahegao.none'), img: gaggedNone, value: 'none' },
      { id: 2, title: t('filters.ahegao.nun'), img: gaggedNun, value: 'nun' },
      { id: 3, title: t('filters.ahegao.school'), img: gaggedStudent, value: 'student' },
      { id: 4, title: t('filters.ahegao.teacher'), img: gaggedTeacher, value: 'teacher' },
      { id: 5, title: t('filters.ahegao.nurse'), img: gaggedNurse, value: 'nurse' },
    ]
    // Anal
    const analTypes = [
      { id: 1, title: t('filters.ahegao.none'), img: analNone, value: 'none' },
      { id: 2, title: t('filters.ahegao.nun'), img: analNun, value: 'nun' },
      { id: 3, title: t('filters.ahegao.school'), img: analStudent, value: 'student' },
      { id: 4, title: t('filters.ahegao.teacher'), img: analTeacher, value: 'teacher' },
      { id: 5, title: t('filters.ahegao.nurse'), img: analNurse, value: 'nurse' },
    ]
    // Mission
    const misionTypes = [
      { id: 1, title: t('filters.ahegao.none'), img: missionNone, value: 'none' },
      { id: 2, title: t('filters.ahegao.nun'), img: missionNun, value: 'nun' },
      { id: 3, title: t('filters.ahegao.school'), img: missionStudent, value: 'student' },
      { id: 4, title: t('filters.ahegao.teacher'), img: missionTeacher, value: 'teacher' },
      { id: 5, title: t('filters.ahegao.nurse'), img: missionNurse, value: 'nurse' },
    ]
    // Mission
    const titsBlowjobTypes = [
      { id: 1, title: t('filters.ahegao.none'), img: titsjobNone, value: 'none' },
      { id: 2, title: t('filters.ahegao.nun'), img: titsjobNun, value: 'nun' },
      { id: 3, title: t('filters.ahegao.school'), img: titsjobStudent, value: 'student' },
      { id: 4, title: t('filters.ahegao.teacher'), img: titsjobTeacher, value: 'teacher' },
      { id: 5, title: t('filters.ahegao.nurse'), img: titsjobNurse, value: 'nurse' },
    ]
    // Male Blowjob
    const maleBlowjobTypes = [
      { id: 1, title: t('filters.posesTypes.maleBlowjob'), img: maleBlowJob, value: 'none' },
    ]

    watch(() => _.isOpenFilters, (newVal, oldVal) => {
      const relatedStep = currentSteps.value.find(el => el.relatedSelectedTypeId === _.selectedType);

      if (relatedStep && relatedStep.callActionWithoutRenderPopup && _.isOpenFilters) {
        handleGenerate();
        closeFilter();
      }
    });
    watch(() => _.selectedType, (newType) => {
      activeGenerationType.value = newType;
      activeStep.value = 1;
    });

    const posesList = [
      { id: 1, title: t('filters.posesTypes.cumshot'), img: cumshotNone, child: cumshotTypes, keygen: 'cumshot', category: "boobs in cum" },
      { id: 2, title: t('filters.posesTypes.titsJob'), img: titsjobNone, child: titsBlowjobTypes, keygen: 'titsjob', category: "titsjob" },
      { id: 3, title: t('filters.posesTypes.bbcblowjob'), img: noneBBCImg, child: bbcTypes, keygen: 'bbc', category: "blowjob" },
      { id: 4, title: t('filters.posesTypes.cuminmouth'), img: noneMouth, child: cumMouthTypes, keygen: 'cuminmouth', category: "cum in mouth" },
      { id: 5, title: t('filters.posesTypes.cumface'), img: faceCumWoman, child: faceCumTypes, keygen: 'cumface', category: "cum on face" },
      { id: 6, title: t('filters.posesTypes.dickcum'), img: dickCumNone, child: dickCumTypes, keygen: 'dickcum', category: "cum on face" },
      { id: 7, title: t('filters.posesTypes.ahegao'), img: ahegaoNone, child: ahegaoTypes, keygen: 'ahegao', category: "ahegao" },
      { id: 8, title: t('filters.posesTypes.breastclamp'), img: breastNone, child: breastTypes, keygen: 'breast', category: "breast clamp" },
      { id: 9, title: t('filters.posesTypes.mission'), img: missionNone, child: misionTypes, keygen: 'mission', category: "missioniere" },
      { id: 10, title: t('filters.posesTypes.gagged'), img: gaggedNone, child: gaggedTypes, keygen: 'gagged', category: "ball gag" },
      { id: 11, title: t('filters.posesTypes.anal'), img: analNone, child: analTypes, keygen: 'anal', category: "analride" },
      { id: 12, title: t('filters.posesTypes.maleBlowjob'), img: maleBlowJob, child: maleBlowjobTypes, keygen: 'maleblowjob', category: "maleblowjob" },
    ];

    const poseOptions = computed(() => {
      const found = posesList.find(item => item.id === selectedPoses.value);
      return found && found.child ? found.child : [];
    });

    const isShowPopup = computed(() => {
      const isCurrentPageHasRelatedSelection = currentStep.value && currentStep.value.options.length > 0;
      return (isCurrentPageHasRelatedSelection || !currentStep.value.isFinal) && _.isOpenFilters;
    });

    const buildDynamicSteps = computed(() => {
      const basicStep = {
            step: 1,
            title: { base: "Choose the image ", highlight: "format", class: "green-text", tail: " you need" },
            options: undressLists,
            generate: () => {
              const selectedClothes = undressLists.find(item => item.id === activeUndressListType.value);
              emit("handleGenerate", {
                generation_type:  selectedClothes ? selectedClothes.title.toLowerCase() : "default",
                character_type: "black",
                type: "inpaint"
              });
              emit('closeModal')
            },
            isFinal: true,
            viewMode: 'grid-full-size',
            activeItem: activeUndressListType
          }

          const trialStep = {
                step: 1,
                title: "Clothes",
                options: [],
                generate: () => {
                  console.log('generate')
                  emit("handleGenerate", {
                    generation_type:  "bikini",
                    character_type: "black",
                    type: "inpaint"
                  })
                  emit('closeModal')
                },
                isFinal: true,
                relatedSelectedTypeId: 1,
                callActionWithoutRenderPopup: true,
                activeItem: null
              }
      console.log('_.hasOneTria', _.hasOneTrial)
      return _.hasOneTrial ? trialStep : basicStep;
    })

    const stepsConfig = computed(() => ({
      1: [  {
        step: 1,
        title: { base: "Choose the image ", highlight: "format", class: "green-text", tail: " you need" },
        options: undressLists,
        generate: () => {
          const selectedClothes = undressLists.find(item => item.id === activeUndressListType.value);
          emit("handleGenerate", {
            generation_type:  selectedClothes ? selectedClothes.title.toLowerCase() : "default",
            character_type: "black",
            type: "inpaint"
          });
          emit('closeModal')
        },
        isFinal: true,
        viewMode: 'grid-full-size',
        activeItem: activeUndressListType
      } ], // Clothes
      2: [ // Undress
        {
          step: 1,
          relatedSelectedTypeId: 2,
          title: "Undress Generation",
          subtitle: "Generate Image",
          options: [],
          generate: () => {
            emit("handleGenerate", { type: "undress" })
            emit('closeModal')
          },
          isFinal: true,
          callActionWithoutRenderPopup: true,
          activeItem: null
        },
      ],
      3: [ // Sex Poses
        {
          step: 1,
          title: { base: "Choose a type of", highlight: " Sex Poses", class: "green-text" },
          options: posesList,
          nextStep: 2,
          isHideStepProgress: true,
          viewMode: 'grid',
          activeItem: selectedPoses
        },
        {
          step: 2,
          title: { base: "Selected a format of", highlight: ` ${selectedPoseFromList.value.title}`, class: "green-text" },
          subtitle: { base: "Select ", highlight: "Type", class: "green-text", tail: " of Images" },
          options: poseOptions.value,
          prevStep: 1,
          activeItem: selectedOutfits,
          isFinal: true,
          generate: () => {
            const poseStyle = selectedPoseFromList.value.child.find(item => item.id === selectedOutfits.value);
            emit("handleGenerate", {
              generation_type: selectedPoseFromList.value.category,
              character_type: poseStyle.value || "none",
              type: "poses"
            });
            emit('closeModal')
          },
        },
      ],
    })
    );
    const selectedPoseFromList = computed(() => posesList.find(item => item.id === selectedPoses.value));
    const currentSteps = computed(() => stepsConfig.value[activeGenerationType.value] || stepsConfig.value[1]);
    const currentStep = computed(() => currentSteps.value.find(step => step.step === activeStep.value) || currentSteps.value[0]);

    const closeFilter = () => {
      activeStep.value = 1;
      store.commit("removeAllModal");
      emit("closeModal");
    };

    const handleSelect = (selectedItem) => {
      if (currentStep.value.activeItem) {
        currentStep.value.activeItem.value = selectedItem.id;
        if (currentStep.value.activeItem === selectedPoses) {
          selectedPoses.value = selectedItem.id;
        } else if (currentStep.value.activeItem === selectedOutfits) {
          selectedOutfits.value = selectedItem.id;
        }
      }
    };

    const handleGenerate = () => {
      if (currentStep.value.generate) {
        currentStep.value.generate();
        activeStep.value = 1;
        store.commit("removeAllModal");
        emit("closeModal");
      }
    };

    const nextStep = () => {
      const step = currentSteps.value.find(s => s.step === activeStep.value);
      if (step && step.nextStep) {
        activeStep.value = step.nextStep;
      } else if (step && step.isFinal) {
        handleGenerate();
      }
    };

    const prevStep = () => {
      const step = currentSteps.value.find(s => s.step === activeStep.value);
      if (step && step.prevStep) {
        activeStep.value = step.prevStep || 1;
      } else {
        closeFilter()
      }
    };

    return {
      activeStep,
      activeGenerationType,
      activeUndressListType,
      activeTits,
      activeBack,
      activeBody,
      activeAge,
      selectedPoses,
      poseOptions,
      selectedOutfits,
      currentStep,
      closeFilter,
      handleSelect,
      handleGenerate,
      isShowPopup,
      nextStep,
      prevStep,
      stepsConfig,
      currentSteps,
      buildDynamicSteps,
      modules: [EffectFade, Pagination, Navigation],
    };
  }
};
</script>

<style lang="scss" scoped>
.settings_filters_popup {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgb(22, 22, 22);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  margin: 0 auto;
  padding: 20px 30px;
  border-radius: 15px;
  width: 900px;
  overflow: hidden;

  .show-mobile {
    display: none;
  }

  &-title {
    color: #FFF;
    text-align: center;
    font-size: 40px;
    text-transform: capitalize;
    margin-bottom: 30px;

    @media screen and (max-width: 768px) {
      font-size: 30px;
      margin-bottom: 10px;
    }
  }

  &-holder {
    overflow: auto;
    height: 100%;

    &_head {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 15px;

      &_title {
        font-size: 40px;
        font-weight: 700;
        text-align: center;
        margin-bottom: 20px;

        @media screen and (max-width: 768px) {
          font-size: 30px;
          margin-bottom: 10px;
        }
      }

      &_icon {
        cursor: pointer;
        position: absolute;
        top: 10px;
        right: 10px;
      }
    }
  }

  &-body {
    position: relative;

    img {
      width: 100%;
      object-fit: cover;
      height: 100%;
      max-height: 700px;
    }
  }

  &-buttons {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    margin-top: 15px;
    position: absolute;
    gap: 15px;
    top: 10px;
    left: 20px;

    button {
      width: 30px;
      height: 30px;
      border: none;
      background-color: transparent;
    }
  }

  &--step {
    height: 100%;
    padding-bottom: 70px;

    &-number {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 75px;
      gap: 8px;
      text-align: center;

      img {
        width: 75px;
        height: 75px;
      }

      &-holder {
        display: flex;
        align-items: flex-start;
        justify-content: center;
        margin-bottom: 15px;
        position: relative;
        gap: 64px;

        @media screen and (max-width: 768px) {
          gap: 40px;
          margin-bottom: 10px;
        }
      }

      @media screen and (max-width: 428px) {
        width: 45px;
      }
    }
  }

  &--action {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    bottom: 40px;
    left: 0;
    width: 100%;
    padding: 0 40px;

    &_button {
      color: #000;
      text-align: center;
      font-size: 36px;
      font-weight: 600;
      border: none;
      position: relative;
      padding: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      margin: 0 auto;
      max-width: 563px;
      border-radius: 20px;
      background: #ACF601;
    }

    &-left-button {
      color: #000;
      text-align: center;
      font-size: 36px;
      font-weight: 600;
      border: none;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 30px;
      background: #ACF601;

      @media screen and (max-width: 480px) {
        margin-left: 10px;
      }

      &:after {
        content: '';
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        border-color: transparent;
        border-style: solid;
        border-width: 40px 40px 40px 0;
        right: 100%;
        border-right-color: #ACF601 !important;

        @media screen and (max-width: 768px) {
          border-width: 20px 20px 20px 0;
        }
      }
    }

    &-right-button {
      color: #000;
      text-align: center;
      font-size: 36px;
      font-weight: 600;
      border: none;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 30px;
      background: #ACF601;

      @media screen and (max-width: 480px) {
        margin-right: 10px;
      }

      &:after {
        content: '';
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        border-color: transparent;
        border-style: solid;
        border-width: 40px 0 40px 40px;
        left: 100%;
        border-left-color: #ACF601 !important;

        @media screen and (max-width: 768px) {
          border-width: 20px 0 20px 20px;
        }
      }
    }

    button {
      @media screen and (max-width: 768px) {
        font-size: 18px;
        padding: 2px 4px;
      }
    }
  }

  &-option {
    margin-bottom: 20px;
    width: 100%;
    position: relative;

    :deep {
      &-wrapper:not(.option-wrapper-main) {
        gap: 10px;
        justify-content: space-between;

        .settings_filters_popup-option_item-description-image {
          width: 192px;
          height: 256px;
          display: flex;
          align-items: center;
          justify-content: center;

          img {
            width: initial;
            height: 100%;
          }
        }
      }
    }

    &-wrapper {
      display: flex;
      align-items: center;
      justify-content: space-around;
      flex-wrap: wrap;

      &.option-wrapper-poses {
        justify-content: flex-start;
        margin-bottom: 10px;

        .settings_filters_popup-option-poses_item {
          width: 25%;
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        @media screen and (max-width: 768px) {
          // justify-content: flex-start;
          flex-wrap: nowrap;
          overflow-x: auto;

          .settings_filters_popup-option-poses_item {
            width: 100%;
            height: auto;
          }
        }
      }

      &.option-wrapper-main {
        justify-content: center;
        gap: 90px;

        @media screen and (max-width: 768px) {
          gap: 10px;

          :deep {
            .settings_filters_popup-option_item-description-image {
              width: 174px;
              height: 300px;
            }
          }
        }

        @media screen and (max-width: 428px) {
          :deep {
            .settings_filters_popup-option_item-description-image {
              width: 126px;
              height: 220px;
            }
          }
        }
      }

      &.option-wrapper-undress {
        justify-content: center;
        gap: 30px;

        @media screen and (max-width: 768px) {
          gap: 10px;

          :deep {
            .settings_filters_popup-option_item-description-image {
              img {
                width: 100%;
                height: initial;
                min-height: initial;
              }
            }
          }
        }
      }

      @media screen and (max-width: 768px) {
        align-items: flex-start;
      }
    }
  }

  .settings_filters_popup-pagination {
    width: 100%;

    &-arrow {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      z-index: 3;
      width: 43px;
      height: 43px;
      flex-shrink: 0;
      border-radius: 50%;
      background-color: #ACF601;
      color: #000;
      font-size: 25px !important;

      &:after {
        font-size: inherit;
      }
    }

    &_left {
      left: 0;
      right: initial;
    }

    &_right {
      left: initial;
      right: 0;
    }
  }

  .swiper-block {
    position: relative;
  }

  .green-text {
    color: #ACF601;
  }

  @media screen and (max-width: 768px) {
    width: 90%;
    padding: 25px 13px;

    .show-mobile {
      display: flex !important;
    }

    .hide-mobile {
      display: none !important;
    }
  }

}
</style>

